import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IJadaiReceiptDetail } from "../jadaiReceiptModel";
import moment from "moment";

export const findAllJadaiReceipt = createAsyncThunk(
  "JadaiReceipt/FindAllJadaiReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/FindAllJadaiReceipt`,
        formdata,
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fatching Jadai Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createJadaiReceipt = createAsyncThunk(
  "JadaiReceipt/InsertJadaiReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/InsertJadaiReceipt`,
        formdata,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Creating Jadai Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateJadaiReceipt = createAsyncThunk(
  "JadaiReceipt/UpdateJadaiReceipt",
  async (ghatReceipt: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/UpdateJadaiReceipt`,
        ghatReceipt,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Jadai Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteJadaiReceipt = createAsyncThunk(
  "JadaiReceipt/DeleteJadaiReceipt",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/DeleteJadaiReceipt`,
        { jadai_receipt_guid: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Delete Jadai Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getJadaiReceiptById = createAsyncThunk(
  "JadaiReceipt/FindByIDJadiaReceipt",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/FindByIDJadiaReceipt`,
        { jadai_receipt_guid: ID },
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        jadai_receipt_guid: result.jadai_receipt_guid,
        karigar_id: result.karigar_id,
        receipt_no: result.receipt_no,
        karigar_name: result.karigar_name,
        karigar_nick_name: result.karigar_nick_name,
        receipt_date: result.receipt_date
          ? moment(result.receipt_date, "YYYY-MM-DD").toDate()
          : "",
        jadai_receipt_order: result.jadai_receipt_order
          ? result.jadai_receipt_order?.map((item: any) => ({
              ...item,
              issize: item.issize ? item.issize : false,
              ForOpenSettings: item?.ForOpenSettings
                ? item?.ForOpenSettings
                : false,
              Dank: item?.Dank ? item?.Dank : 0,
              isweight: item.isweight ? item.isweight : false,
              isdesign: item.isdesign ? item.isdesign : false,
              iscaret: item.iscaret ? item.iscaret : false,
              isgoldcolor: item.isgoldcolor ? item.isgoldcolor : false,
              iseverythingasdescription: item.iseverythingasdescription
                ? item.iseverythingasdescription
                : false,
              ispolishcolor: item.ispolishcolor ? item.ispolishcolor : false,
              isfinishorder: item.isfinishorder ? item.isfinishorder : false,
            }))
          : [],
      } as IJadaiReceiptDetail;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ghat Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteJadaiReceiptOrderItem = createAsyncThunk(
  "JadaiReceipt/DeletejadiaReceiptProcess",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/DeletejadiaReceiptProcess`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Jadai Receipt Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteJadaiReceiptUsedItem = createAsyncThunk(
  "JadaiReceipt/DeleteJadiaReceiptIssuedByKarigarItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/DeleteJadiaReceiptIssuedByKarigarItem`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Jadai Receipt Approval Item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// export const deleteGhatReceiptUsedByKarigarItem = createAsyncThunk(
//   "GhatReceipt/DeleteGhatReceiptIssuedByKarigarItem",
//   async (ID: number) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/GhatReceipt/DeleteGhatReceiptIssuedByKarigarItem`,
//         { id: ID }
//       );
//       SuccessToast(response.data?.Details || "Success");
//       return response.data;
//     } catch (error: any) {
//       ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error deleting Ghat Receipt Process:", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );

export const findByOrderNoJadaiReceipt = createAsyncThunk(
  "JadaiReceipt/FindByOrderNoJadaiReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/FindByOrderNoJadaiReceipt`,
        formdata,
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        jadai_issue_id: result.jadai_issue_id,
        order_id: result.order_id,
        order_no: result.order_no,
        item_id: result.item_id,
        item_category_id: result.item_category_id,
        with_without_variation: result.with_without_variation,
        purity_id: result.purity_id,
        weight: result.weight,
        order_vepari_remark: result.remark,
        order_issue_remarks: result.remarks,
        order_process_description: result.process_description,
        item_image: result.item_imag,
        approval_items: result.approval_items,
        sizedetails: result.sizedetails,
        order_date: result.order_date,
        delivery_date: result.delivery_date,
        product_name: result.item_name,
        category_name: result.category_name,
        sub_category_name: result.subcategory_name,
        order_estimate_weight: result.order_estimate_weight,
        size: result.size,
        purity: result.PurityValue,
        Carat: result.Carat,
        color: result.color,
        priority: result.priority,
        karigar_name: result.karigar_name,
        given_date: result.given_date,
        receive_date: result.receive_date,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllOrderJadaiIssue = createAsyncThunk(
  "JadaiReceipt/JadaiPendingOrderList",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/JadaiPendingOrderList`,
        formdata,
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Deleting Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const JadaiReceiptImageUpdate = createAsyncThunk(
  "JadaiReceipt/JadiaReceiptImageUpdate",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/JadiaReceiptImageUpdate`,
        formdata,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Jadai Receipt Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteJadiaReceiptImage = createAsyncThunk(
  "JadaiReceipt/DeletejadaireceiptImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/JadaiReceipt/DeletejadaireceiptImage`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Jadai Receipt Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
